import React, { useState } from "react";
import { Button, Input } from "antd";
import * as AzureService from "../../api/ticketsApiAzure";
import *as tConst from "../../common/Constants";





const AddNew = ({ ...props }) => {
    // eslint-disable-next-line no-unused-vars
    const [title, setTitle] = useState("");

    // const inputStyle = { width:'100%' }

    if (props.showAddNew) {
        return (
            <>

                <label>New titles</label>&nbsp;
                <Input placeholder="type in titles, separate with ';'" value={title} onChange={(e) => setTitle(e.target.value)} style={{ width: 300 }} />&nbsp;
                <Button onClick={() => {
                    AddNewTickets(props.auth, title, props.parent, props.onSetRefresh);
                    props.onClose();
                }}>Save</Button>
            </>
        )
    }
    else {
        return <></>
    }


}

export default AddNew;

function AddNewTickets(auth, titles, parent, onSetRefresh) {
    let titlesArray = titles.split(';');
    titlesArray.forEach(title => {
        const newItem = {
            newTitle: title,
            path: parent.fields[tConst.AF_AREA_PATH],
            tags: parent.fields[tConst.AF_TAGS] ? parent.fields[tConst.AF_TAGS] : "",
            //TODO: Decide what wo do about teams
            teams: ";", //(parent.Teams ? parent.Teams.join(";") : ""),
            parentId: parent.id,
            initiative: parent.fields[tConst.AF_INITIATIV] ? parent.fields[tConst.AF_INITIATIV] : "",
            startIteration: parent.fields[tConst.AF_START_ITERATION],
            endIteration: parent.fields[tConst.AF_END_ITERATION],
            PlanningPri: (parent.planningPri ? (parent.planningPri + 0.01) : 99999)
        }
        let type = "Initiative";
        // If the parent is a RnD Planning epic, we need to create an epic instead of an initiative
        // TODO: Create a more robust solution for all projects
        if (parent.fields[tConst.AF_PROJECT] === "RnD Planning"  || parent.fields[tConst.AF_PROJECT] === "Product Discovery Planning") {
            type = "Epic";
        }
        AzureService.createTicketInternal(auth, parent.fields[tConst.AF_PROJECT], type, JSON.stringify(CreateData(newItem))).then((response) => {
            onSetRefresh();
        })
    })
}

function CreateData(newItem) {
    const _start = new Date(newItem.startIteration);
    const _end = new Date(newItem.endIteration);

    const data = [
        {
            "op": "add",
            "path": "/fields/" + tConst.AF_TITLE,
            "from": null,
            "value": newItem.newTitle
        },
        {
            "op": "add",
            "path": "/fields/" + tConst.AF_AREA_PATH,
            "value": newItem.path
        },
        {
            "op": "add",
            "path": "/fields/" + tConst.AF_TAGS,
            "value": newItem.tags
        },
        {
            "op": "add",
            "path": "/fields/" + tConst.AF_START_ITERATION,
            "value": _start
        },
        {
            "op": "add",
            "path": "/fields/" + tConst.AF_END_ITERATION,
            "value": _end
        },
        {
            "op": "add",
            "path": "/fields/" + tConst.AF_INITIATIV,
            "value": newItem.initiative
        },
        {
            "op": "add",
            "path": "/fields/" + tConst.AF_TEAMS,
            "value": newItem.teams
        },
        {
            "op": "add",
            "path": "/fields/" + tConst.AF_PLANNING_PRIORITY,
            "value": newItem.PlanningPri
        }

    ]

    if (newItem.parentId !== null && newItem.parentId !== 0) {
        data.push({
            "op": "add",
            "path": "/relations/-",
            "value": {
                "rel": "System.LinkTypes.Hierarchy-Reverse",
                "url": tConst.AZURE_DEVOPS_API_URI + `/wit/workItems/${newItem.parentId}`
            }
        });

    }

    console.log("CreateData: " + JSON.stringify(data, null, 4))

    return data;
}
